import { gql } from '@apollo/client';

import { PROPERTY_IMAGES_FRAGMENT } from '../fragments/propertyImages';
import { PROPERTY_LINKS_FRAGMENT } from '../fragments/propertyLinks';
import { PROPERTY_BID_FRAGMENT } from '../fragments/propertyBid';
import { PROPERTY_3DVIEWING_FRAGMENT } from '../fragments/property3dViewing';
import { PROPERTY_NYBYGG_FRAGMENT } from '../fragments/propertyNybygg';
import { PROPERTY_PROJECT_LOGOS_FRAGMENT } from '../fragments/propertyProjectLogos';
import { PROPERTY_BROKERS_FRAGMENT } from '../fragments/propertyBrokers';
import { PROPERTY_OFFICE_FRAGMENT } from '../fragments/propertyOffice';

export const GET_PROPERTY_TOP_QUERY = gql`
  ${PROPERTY_IMAGES_FRAGMENT}
  ${PROPERTY_LINKS_FRAGMENT}
  ${PROPERTY_BID_FRAGMENT}
  ${PROPERTY_3DVIEWING_FRAGMENT}
  ${PROPERTY_NYBYGG_FRAGMENT}
  ${PROPERTY_PROJECT_LOGOS_FRAGMENT}
  ${PROPERTY_BROKERS_FRAGMENT}
  ${PROPERTY_OFFICE_FRAGMENT}
  query GetPropertyTop($input: PropertyInput) {
    getProperty(input: $input) {
      id
      description
      hovedoppdrag
      sold
      permalink
      nybygg {
        profile
        showPriceList
      }
      ...PropertyImages
      ...PropertyLinks
      ...PropertyBid
      ...Property3DViewing
      ...PropertyNybygg
      ...PropertyProjectLogos
      ...PropertyBrokers
      ...PropertyOffice
    }
  }
`;
